<template>
  
</template>

<script>
import anime from 'animejs'

export default {
  data () {
    return {
      circle01: null,
      circle03: null,
      circle04: null,
      circle05: null,
      dots01: null,
      dots02: null,
      dots03: null,
      logo3M: null
    }
  },

  methods: {
    animateCircle01 () {
      const scrollY = window.scrollY
      // console.log(scrollY)
      if (scrollY < this.circle01.duration) {
        this.circle01.seek(scrollY * 10)
      }
    },

    animateCircle03 () {
      const scrollY = window.scrollY
      if (scrollY > 200) {
        if (scrollY < this.circle03.duration) {
          const seekPos = (scrollY / this.circle03.duration) * 1e4
          this.circle03.seek(seekPos)
        }
      }
    },

    animateCircle04 () {
      const scrollY = window.scrollY
      if (scrollY > 1200) {
        if (scrollY < this.circle04.duration) {
          const seekPos = (scrollY / this.circle04.duration) * 1e4
          this.circle04.seek(seekPos)
        }
      }
    },

    animateCircle05 () {
      const scrollY = window.scrollY
      if (scrollY > 1600) {
        if (scrollY < this.circle05.duration) {
          const seekPos = (scrollY / this.circle05.duration) * 1e4
          this.circle05.seek(seekPos)
        }
      }
    },

    animateDots02 () {
      const scrollY = window.scrollY
      if (scrollY > 400) {
        this.dots02.play()
      }
    },

    animateDots03 () {
      const scrollY = window.scrollY
      if (scrollY > 1900) {
        this.dots03.play()
      }
    },

    animateLogo3M () {
      const scrollY = window.scrollY
      if (scrollY < this.logo3M.duration) {
        const seekPos = (scrollY / this.logo3M.duration) * 1e4
        this.logo3M.seek(seekPos)
      }
    }
  },

  mounted () {
    this.circle01 = anime({
      targets: '.Circle--01',
      duration: 7000,
      scale: 1.5,
      easing: 'easeInOutCubic',
      autoplay: false
    })

    this.circle03 = anime({
      targets: '.Circle--03',
      duration: 5000,
      scale: 1.5,
      easing: 'easeInOutCubic',
      autoplay: false
    })

    this.circle04 = anime({
      targets: '.Circle--04',
      duration: 5000,
      scale: 1.5,
      easing: 'easeInOutCubic',
      autoplay: false
    })

    this.circle05 = anime({
      targets: '.Circle--05',
      duration: 7000,
      scale: 1.25,
      easing: 'easeInOutCubic',
      autoplay: false
    })

    this.dots01 = anime({
      targets: '.Dots-wrapper--01 .Dots-list-dot',
      opacity: 1,
      easing: 'easeInOutCubic',
      delay: (el, i, l) => i * 100
    })

    this.dots02 = anime({
      targets: '.Dots-wrapper--02 .Dots-list-dot',
      opacity: 1,
      easing: 'easeInOutCubic',
      delay: (el, i, l) => i * 100,
      autoplay: false
    })

    this.dots03 = anime({
      targets: '.Dots-wrapper--03 .Dots-list-dot',
      opacity: 1,
      easing: 'easeInOutCubic',
      delay: (el, i, l) => i * 100,
      autoplay: false
    })

    this.logo3M = anime({
      targets: '#path3356',
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'linear',
      duration: 2500,
      autoplay: false
    })

    window.addEventListener('scroll', this.animateCircle01)
    window.addEventListener('scroll', this.animateCircle03)
    window.addEventListener('scroll', this.animateCircle04)
    window.addEventListener('scroll', this.animateCircle05)
    window.addEventListener('scroll', this.animateDots02)
    window.addEventListener('scroll', this.animateDots03)
    window.addEventListener('scroll', this.animateLogo3M)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Animation-controller.vue